// Simplified Sticky Header Hover Fix
// Only handles underlining/border logic if needed, lets CSS handle colors.

(function () {
  'use strict';

  function cleanHeaderHover() {
    const header = document.querySelector('.shopify-section-header-sticky');
    if (!header) return;

    // We let the new refined CSS handle the colors.
    // This script can be empty or removed if CSS is sufficient.
  }

  document.addEventListener('DOMContentLoaded', cleanHeaderHover);
  document.addEventListener('shopify:section:load', cleanHeaderHover);
})();
